import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Home = lazy(() => import('./pages/Home'));
const List = lazy(() => import('./pages/List'));
const Detail = lazy(() => import('./pages/Detail'));
const ActivityTaskForm = lazy(() => import('./pages/ActivityTaskForm'));

const getBaseName = () => {
  if (typeof window === 'undefined') return '/';
  const { pathname } = window.location;

  if (pathname === '/' || pathname === '') {
    return '/';
  }

  if (pathname.endsWith('/index.html')) {
    const withoutIndex = pathname.slice(0, -'/index.html'.length);
    return withoutIndex.length > 1 ? withoutIndex.replace(/\/$/, '') : '/';
  }

  const firstSegment = pathname.split('/').filter(Boolean)[0];
  if (firstSegment === 'free' || firstSegment === 'paid') {
    return `/${firstSegment}`;
  }

  return '/';
};

const routers = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#12171C' }} />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/activity/form',
    element: (
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#12171C' }} />}>
        <ActivityTaskForm />
      </Suspense>
    ),
  },
  {
    path: '/list',
    element: (
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#12171C' }} />}>
        <List />
      </Suspense>
    ),
  },
  {
    path: '/game/:id',
    element: (
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#12171C' }} />}>
        <Detail />
      </Suspense>
    ),
  },
], {
  basename: getBaseName(),
});

const Router = () => {
  return <RouterProvider router={routers}></RouterProvider>;
};

export default Router;
